import React, { Component } from 'react';
import { connect } from 'react-redux';

import Context from 'components/notebook/notebookPopout/context/Context';
import Predictions from 'components/notebook/notebookPopout/predictions/Predictions';
import Results from 'components/notebook/notebookPopout/results/Results';
import Summary from 'components/notebook/notebookPopout/summary/Summary';
import Reflection from 'components/notebook/notebookPopout/reflection/Reflection';


import './NotebookPopout.scss'

import SceneData from 'data/scene.json';
import { withTranslation } from 'react-i18next'
import {PopoutFooter} from '@learningblocks/storybook-components/lib/PopoutFooter';
import {MaterialSection} from '@learningblocks/protocol-components/lib/MaterialSection';

import {
    setModal,
    showModal
} from '../../../actions'

const sections = [
    "Context",
    "Materials",
    "Predictions",
    "Protocol",
    "Results",
    "Reflection",
    "Summary"
]


class NotebookPopout extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    // Next button aria-label
    nextAriaLabel = () => {
        switch (this.props.section) {
            case "Context":
                return "Next button. Select to advance to the Context section."
            case "Materials":
                return "Next button. Select to advance to the Predictions section.";
            case "Predictions":
                return "Next button. Select to advance to the Results section.";
            case "Results":
                return "Next button. Select to advance to the Summary section.";
            case "Summary":
            return "Next button. Select to advance to the Reflections section.";
            case "Reflection":
            return "";
            default:
                break;
        }
    }

    //TODO: choose which to render based on Redux state
    nextSection = () => {
      if(sections.indexOf(this.props.section) === (sections.length - 1)){
        this.props.setModal({
            display: false,
            type: "END_SIMULATION",
            size: 'md',
            connect: -1
          })
          this.props.showModal({display: true})
      } else {
        this.props.onSelect({section: sections[sections.indexOf(this.props.section) + 1]});
      }
    }

    previousSection = () => {
        if(sections.indexOf(this.props.section) >=1 ){
            this.props.onSelect(
                {section: sections[sections.indexOf(this.props.section) - 1]}
            );
        }
    }

    materialGroups = () => {
        const groups = {
            "Reagents": {
                "description": this.props.t("Chemicals that can be used in this experiment"),
                "components": ["Solutions"]
            },
            "Micropipetting Equipment": {
                "description": this.props.t("Used to measure small volumes"),
                "components": ["Pipettes", "Tip Boxes"]
            },
            "Other Equipment": {
                "description": "",
                "components": ["Blotting Paper", "Trash"]
            }
        }
        return Object.entries(groups).reduce((accumulator, [key, value]) => {
            accumulator[this.props.t(key)] = value;
            return accumulator;
        }, {});
    }

    render() {
        let body = ''
        switch (this.props.section) {
            case "Context":
                body = <Context />;
                break;
            case "Materials":
                body = <MaterialSection
                    materials={SceneData}
                    grouping={this.materialGroups()}
                    lang={this.props.i18n.language}
                />;
                break;
            case "Predictions":
                body = <Predictions />;
                break;
            case "Results":
                body = <Results />;
                break;
            case "Summary":
                body = <Summary />;
                break;
            case "Reflection":
                body = <Reflection />;
                break;
            default:
                break;
        }

        return (
            <div className="notebook-popout">
                <div className="popout-content">
                  <div className="popout-header">
                      <h4 tabIndex={0} aria-label={this.props.t("Lab notebook "+ this.props.section +" section heading.")}>{this.props.t(this.props.index +". "+ this.props.section)}</h4>
                  </div>

                  <div className="popout-body">
                      {body}
                  </div>
                </div>
                <PopoutFooter
                    lang={this.props.i18n.language}
                    prevSection={this.previousSection}
                    sectionIndex={sections.indexOf(this.props.section)}
                    sectionLength={sections.length}
                    section={this.props.section.toLowerCase()}
                    nextSection={this.nextSection}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        index: ownProps.index,
        sectionSelected: state.notebook.sectionSelected,
        onSelect: ownProps.onSelect,
    }
}

export default connect(mapStateToProps, {
    setModal,
    showModal
})(withTranslation()(NotebookPopout));
